export default {
  tableHeader: {
    dataId: 'Feature',
    spearmanCorrelationCoeff: 'Nichtlinearer Korrelationskoeffizient (Spearman)',
    pearsonCorrelationCoeff: 'Linearer Korrelationskoeffizient (Pearson)',
  },
};
